/* tslint:disable:typedef-whitespace no-trailing-whitespace */

/**
 *
 * @class Alert
 *
 * @brief the object we use for system alerts, intended to allow for multiple alerts to be posted to
 * the top of the application that can fade out automatically, can persist accross navigation clicks
 * and can be dismissed by the user.
 *
 * Angular tutorial on toaster style alerts
 * @link https://jasonwatmore.com/post/2019/07/05/angular-8-alert-toaster-notifications
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class Alert {

  /** the id of the alert, used to filter streams of alerts */
  id:                   string;

  /** the kind of alert in this stream */
  type:                 AlertType;

  /** the actual message */
  message:              string;

  /** auto close the message? */
  autoClose:            boolean;

  /** persist? */
  keepAfterRouteChange: boolean;

  /** fade out? */
  fade:                 boolean;

  /** standard constructor, allow for partial alert to be given */
  constructor(init?: Partial<Alert>) {

    Object.assign(this, init);
  }
}

/* the kinds of alerts */
export enum AlertType {
  Success= 0,
  Error=   1,
  Info=    2,
  Warning= 3
}
